import React, { useEffect, useState } from "react";
import "./Cart.css";
import { useDispatch, useSelector } from "react-redux";
import { addToCart, calculateTotals, clearCart, removeFromCart } from "../../redux/slices/cartSlice";
import toast from "react-hot-toast";
import { clearUserCart, getAllCart, removeProductFromUserCart, updateUserCart } from "../../services/cartService";
import { Link, useNavigate } from "react-router-dom";

const CartItem = () => {
  const [cartItems, setCartItems] = useState([]);
  const cart = useSelector(state => state.cart.guestCart);
  const dispatch = useDispatch();
  const { userCart } = useSelector((state) => state.cart);
  const totalPrice = useSelector((state) => state.cart.totalPrice);
  const navigate = useNavigate();
  const userId = useSelector((state) => state.auth.userId); 
 console.log("cart",cart)
   useEffect(() => {
       if (userId) {
        const fetchCart = async () => {
          try {
            const cartItems = await getAllCart(userId);
            cartItems.forEach(item => {
              dispatch(addToCart({ item, isGuest: false }));
            });
            // dispatch(addToCart({item:cartItems ,isGuest:false}));
            setCartItems( cartItems);
          } catch (error) {
            console.error("Failed to load cart:", error);
          }
        };
        fetchCart();
      }
    }, []);

console.log(cartItems);
 
  const handleRemoveItem =async (prodGuId,product) => {
    if (!userId) {
      dispatch(removeFromCart({ prodGuId, isGuest: true }));

     
      toast.success( "removed from cart!")
    } else {
      try {
        const cartData = {
          id: product.id,
          guid: product.guid || "",
          version: 0,
          isDeleted: true,
          createdUser: userId,
          createdDate: new Date().toISOString(),
          updatedUser: userId,
          updatedDate: new Date().toISOString(),
          prodGuId: prodGuId,
          quantity: product.quantity,
          shortName: product.shortName || "Unnamed Product",
          retailRate: product.retailRate ?? 0,
          totalPrice: product.retailRate*product.quantity,
          thumbImage: product.thumbImage || ""
        };
        await removeProductFromUserCart(cartData);
        setCartItems((prevCart) =>
          prevCart.filter((item) => item.prodGuId !== prodGuId)
        );
        dispatch(removeFromCart({ prodGuId, isGuest: false }));
        toast.success("Item removed from cart!");
      } catch (error) {
           toast.error("Failed to remove item.");
         }
    }
  };
  const handleClearCart = async () => {
    if (!userId) {
      dispatch(clearCart());
      toast.success("Cart cleared successfully!");
    } 
    else {
      try {
        const cartData = {
          createdUser: userId
        };
       // console.log("clrdata",cartData)
        await clearUserCart(cartData);
        dispatch(clearCart());
        setCartItems([]);
        toast.success("Cart cleared successfully!");
      } catch (error) {
        toast.error("Failed to clear cart.");
      }
    }
  };
  
 


  const handleQuantityChange =async (product, change) => {
    // if (!userId) {
    //   const updatedCart = guestCartItems.map((item) =>
    //     item.prodGuId === product.prodGuId ? { ...item, quantity: Math.max(1, item.quantity + change) } : item
    //   );
      // setGuestCart(updatedCart);
      if (!userId) {
        const updatedQuantity = Math.max(1, product.quantity + change);
        const updatedItem = { ...product, quantity: updatedQuantity };
        dispatch(addToCart({ item: updatedItem, isGuest: true }));
        toast.success("Quantity updated!");
      
      
    } else {
      try {
        const newQuantity = Math.max(1, product.quantity + change);
        const cartData = {
          id: product.id,  
          guid: product.guid || "", 
          version: 0, 
          isDeleted: true, 
          createdUser: userId,
          createdDate: new Date().toISOString(),  
          updatedUser: userId, 
          updatedDate: new Date().toISOString(), 
          prodGuId: product.prodGuId,
          quantity: newQuantity, 
          shortName: product.shortName || "Unnamed Product", 
          retailRate: product.retailRate ?? 0, 
          totalPrice: product.retailRate *newQuantity ,
          thumbImage: product.thumbImage || ""
        };

        //console.log("cartdata",cartData)
        await updateUserCart(cartData);
        setCartItems((prevCart) =>
          prevCart.map((item) =>
            item.prodGuId === product.prodGuId ? { ...item, quantity: newQuantity } : item
          )
        );
        toast.success("Quantity updated!");
      } catch (error) {
        toast.error("Failed to update quantity.");
      }}
  };

  const allCartItems = [...cartItems, ...cart];
 

  const subtotal = allCartItems.reduce((sum, item) => sum + item.retailRate * item.quantity, 0);
  const discount = 0.0;
  const total = subtotal - discount;
  useEffect(() => {
    if(allCartItems.length>0){
    dispatch(calculateTotals({ subtotal, discount, total }));
    }
  }, [allCartItems, dispatch]);


 
  return (
    <section className="pt-5 ftco-cart pb-5">
      {allCartItems.length >0? (
  <>
      <div className="container">

        <div className="row">
          <div className="col-md-12 ">
             <div>
                            <p className="text-white"> Total Count : {allCartItems.length}</p>
                            <a className="btn btn-primary btn-outline-primary rounded-0 mb-3 pb-2" onClick={() => handleClearCart()}>
                            Clear Cart
                          </a>
                        </div>
            <div className="cart-list">

              <table className="col-lg-12 text-white">
                <thead className="thead-primary bg-coffee mt-5 text-left">
                  <tr className="text-left">
                    <th>&nbsp;</th>
                    <th>&nbsp;</th>
                    <th>Product</th>
                    <th>Price</th>
                    <th>Quantity</th>
                    <th>Total</th>
                  </tr>
                </thead>
                <tbody className="">
                  {allCartItems.map((item) => (
                    <tr className="text-center border-bottom border-secondary" key={item?.prodGuId}>
                      <td className="">
                        <a onClick={() => handleRemoveItem(item?.prodGuId,item)} className="bg-transparent border-none"><span className="icon-close"></span></a>
                      </td>
                      <td className="image-prod p-2" >
                  <Link className="nav-link" to={`/product/${item?.guid}`}>
                                            {/* <img
                     src={`https://inventory-api.exodusvacations.in/${item.thumbImage.trim().replace(/^wwwroot\//,'')}`}
                     alt={item.name} width={250} height={200}  className="img-fluid"/> */}
                                              
                                              <img
  src={`https://inventory-api.exodusvacations.in/${item.thumbImage.trim().replace(/^wwwroot\//, "")}`}
  alt={item.name}
  width={100}
  height={80}
  className="img-fluid"
/>
                                              {/* <img src="/images/seracoffee-7.jpeg" alt={item.name} width={200} height={200}
                                                className="img-fluid" />  */}
                                             </Link>
                       
                        </td>
                      <td className="product-name text-left">
                        <h3 className="h3-product">{item?.shortName}</h3>
                        <p className="p-product p-color"></p>
                      </td>
                      <td className="price text-left"> <h5 className="p-product">{item?.retailRate}</h5></td>
                      <td className="quantity">
                      <div className="input-group col-md-6 d-flex mb-3">
                      <span className="input-group-btn mr-2">
                  <button
                    type="button"
                    className="quantity-left-minus p-0 border-0"
                    onClick={() => handleQuantityChange(item,-1)}
                    disabled={item.quantity <= 1} 
                  >
                    <i className="icon-minus"></i>
                  </button>
                </span>
                <input
                  type="text"
                  className="form-control w-25 input-number"
                   value={item.quantity}
                  readOnly
                />
              
                <span className="input-group-btn ml-2">
                  <button
                    type="button"
                    className="quantity-right-plus p-0 m-0"
                    onClick={() => handleQuantityChange(item, 1)}
                  >
                    <i className="icon-plus"></i>
                  </button>
                </span>
                </div>
                       
                      </td>
                      <td className="total text-left"><h5 className="p-product">{(item?.retailRate * item.quantity).toFixed(2)}</h5></td>
                      </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div className="row justify-content-end mt-5">
          <div className="col col-lg-3 col-md-6 cart-wrap">
            <div className="cart-total mb-3 text-white">
              <h3>Cart Totals</h3>
              <p className="d-flex">
    						<span>Subtotal</span>
    						<span>{subtotal.toFixed(2)}</span>
    					</p>
    					<p className="d-flex">
    						<span>Delivery</span>
    						<span>0.00</span>
    					</p>
    					<p className="d-flex">
    						<span>Discount</span>
    						<span>{discount}</span>
    					</p>
    					<hr/>
            	<p className="d-flex total-price">
    						<span>Total</span>
    						<span>{total.toFixed(2)}</span>
    					</p>
            </div>

            {/* write a function for checkout only after login */}
            {userId? (
 <a href="/checkout" className="btn btn-primary p-3 px-xl-4 py-xl-3 rounded-0">
 Proceed to checkout
</a>
            ) : (
<a href="/login" className="btn btn-primary p-3  rounded-0 text-center">login to complete your purchase</a> 
            )}
           
          </div>
        </div>
      </div>
      </>
      ):(
        <div className="text-center py-5">
            <h3 className="text-white">Your Cart is Empty</h3>
            <p className="text-light">Add items to your cart to see them here.</p>
          </div>
      )}
    </section>
  );
};


export default CartItem;
